import ActualizarInformacionProvider from "../providers/actualizarInformacion-provider";
import TokenProvider from "../../commons/providers/token-provider";

class ActualizarInformacionRepository {
    
    constructor() {
        this.actualizarInformacionProvider = new ActualizarInformacionProvider();
        this.tokenProvider = new TokenProvider();
    }

    patchActualizarInformacion = async (datosConsulta) => {
        await this.tokenProvider.getToken();
        return this.actualizarInformacionProvider.patchActualizarInformacion(datosConsulta);
    }

}

export default ActualizarInformacionRepository;